import { setCookie } from './cookie/cookieHandlers'
import { getTimestampByKyiv } from './utils/getTimestampByKyiv'

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('transition-disabled')
})

/** Setting partner refferal id for api.zomro.com */
const params = new URLSearchParams(window.location.search)

if ((params.has('from') || params.has('tech') || params.has('ref')) && params.size === 1) {
  const fromValue = params.get('from') || params.get('tech') || params.get('ref')
  setCookie('billpartner', fromValue, 1)
  if (document.referrer) {
    setCookie('referrer', document.referrer, 1)
  }
}

const currentYearSpan = document.querySelector('[data-current-year]')

if (currentYearSpan) {
  currentYearSpan.innerHTML = `${new Date().getFullYear()}`
}

const tariffElements = document.querySelectorAll('[data-banner-name]')
const bannersElements = document.querySelectorAll('[data-limited-banner]')

const nowTimestamp = new Date().getTime()

/** Logic below unused anymore. Maybe sometimes it will be restored */
// Conditions for banners
const PROMOTIONS_DATES = [
  {
    name: 'promotional-string',
    start: getTimestampByKyiv(2025, 1, 15, 0, 0, 0), // 15 January 2025 00:00 GMT+2
    end: getTimestampByKyiv(2025, 2, 13, 0, 0, 0), // 13 February 2025 00:00 GMT+2
    className: 'shown',
  },
]

// Function of checking conditions
function checkBannerCondition(tariffName) {
  return PROMOTIONS_DATES.find(
    banner =>
      tariffName.toLowerCase().includes(banner.name) &&
      nowTimestamp >= banner.start &&
      nowTimestamp <= banner.end,
  )
}

tariffElements.forEach(tariffElement => {
  const tariffName = tariffElement.getAttribute('data-banner-name')

  const matchedBanner = checkBannerCondition(tariffName)

  if (matchedBanner) {
    tariffElement.classList.add(matchedBanner.className)
  }
})

// Remove banners that do not meet the conditions
bannersElements.forEach(bannerElement => {
  const tariffName = bannerElement.getAttribute('data-banner-name')

  const matchedBanner = checkBannerCondition(tariffName)

  if (!matchedBanner) {
    bannerElement.remove()
  }
})

/** Unused to this place. Below code is used and valid */

const contactLinks = document.querySelectorAll('[data-facebook-contact-event]')

contactLinks.forEach(elem =>
  elem.addEventListener('click', () => {
    window?.fbq('track', 'Contact')
  }),
)
